import api from './api';

export const getParlamentDecisions = async (params) => {
    const response = await api.post('/api/ParlamentDecisions/GetParlamentDecisionses', params);
    return response.data;
};

export const getParlamentDecision = async (guid) => {
    const response = await api.post('/api/ParlamentDecisions/GetParlamentDecisionsById', { guid });
    return response.data;
};

export const createParlamentDecision = async (data) => {
    let fileBase64 = '';
    
    if (data.file) {
        // Önce dosya uzantısını al
        const fileName = data.file.name;
        const fileExt = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
        
        fileBase64 = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const base64Content = reader.result.split(',')[1];
                // Dosya tipine göre uygun MIME type kullan
                const mimeType = fileExt === '.rar' ? 'application/x-rar-compressed' : 'application/zip';
                resolve(`data:${mimeType};base64,${base64Content}`);
            };
            reader.onerror = () => reject(reader.error);
            reader.readAsDataURL(data.file);
        });
    }

    // Dosya adı ve uzantısını ayır
    let originalFileName = '';
    let fileExtension = '';
    
    if (data.file) {
        originalFileName = data.file.name;
        fileExtension = originalFileName.substring(originalFileName.lastIndexOf('.'));
    }

    const response = await api.post('/api/ParlamentDecisions/AddParlamentDecisions', {
        decisionsNo: data.decisionsNo || '',
        header: data.header,
        detail: data.detail,
        Date: data.Date, // Büyük harfli Date parametresi
        fileBase64: fileBase64,
        fileName: data.decisionsNo ? `${data.decisionsNo}${fileExtension}` : originalFileName,
        fileUrl: data.fileUrl || ''
    });
    return response.data;
};

export const updateParlamentDecision = async (guid, data) => {
    let fileBase64 = '';
    let originalFileName = '';
    let fileExtension = '';
    
    if (data.file) {
        // Önce dosya uzantısını al
        originalFileName = data.file.name;
        fileExtension = originalFileName.substring(originalFileName.lastIndexOf('.')).toLowerCase();
        
        fileBase64 = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const base64Content = reader.result.split(',')[1];
                // Dosya tipine göre uygun MIME type kullan
                const mimeType = fileExtension === '.rar' ? 'application/x-rar-compressed' : 'application/zip';
                resolve(`data:${mimeType};base64,${base64Content}`);
            };
            reader.onerror = () => reject(reader.error);
            reader.readAsDataURL(data.file);
        });
    }

    const response = await api.post('/api/ParlamentDecisions/UpdateParlamentDecisions', {
        guid,
        decisionsNo: data.decisionsNo || '',
        header: data.header,
        detail: data.detail,
        Date: data.Date, // Büyük harfli Date parametresi
        fileBase64: fileBase64,
        fileName: data.decisionsNo ? `${data.decisionsNo}${fileExtension}` : originalFileName,
        fileUrl: data.fileUrl || ''
    });
    return response.data;
};

export const deleteParlamentDecision = async (guid) => {
    const response = await api.post('/api/ParlamentDecisions/DeleteParlamentDecisions', { guid });
    return response.data;
};
